import { SettingOutlined } from '@ant-design/icons';
import React from 'react';
import CustomInputsV3 from '@Components/Admin/AdminConfiguration/CustomInputsV3';
import VendorRatingConfig from './VendorRatingConfig';
import CustomReasons from './CustomReasons';
import CustomStatus from './CustomStatus';
import Category from './Category';
import GeneralConfiguration from './GeneralConfiguration';
import Uom from './Uom';
import BatchConfiguration from './BatchConfiguration';
import ExtraCharges from './ExtraCharges';
import documentUINamesConstant from '../../../apis/documentUINamesConstant';

const settingsIcon = <SettingOutlined />;

const generateCommonTabs = (type) => [
  {
    name: 'Field Customization',
    component: <CustomInputsV3 type={type} />,
    props: {},
    key: `${type?.toLowerCase()?.replaceAll(' ', ' ')}/custom-fields`,
  },
];

const generateEntity = (name, entityName, key, tabs) => ({
  name,
  entity_name: entityName,
  key,
  icon: settingsIcon,
  is_active: true,
  tabs,
});

const data = (userData) => {
  const documentUINames = documentUINamesConstant(userData);

  return [
    generateEntity('Inventory', 'product', '/admin-config/inventory', [
      {
        name: 'General Configuration',
        component: <GeneralConfiguration entityType="PRODUCTS" />,
        props: {},
        is_active: true,
        key: '/admin-config/inventory/general',
      },
      {
        name: 'Unit of Measures',
        component: <Uom />,
        is_active: true,
        key: '/admin-config/inventory/uom',
      },
      ...generateCommonTabs('PRODUCTS'),
      {
        name: 'Product Categories', component: <Category />, props: {}, key: '/admin-config/inventory/categories',
      },
      {
        name: 'Batch Configuration', component: <BatchConfiguration />, props: {}, key: '/admin-config/inventory/batch_configuration',
      },
      {
        name: 'Batch Field Customization', component: <CustomInputsV3 type={'BATCH'} />, props: {}, key: '/admin_config/inventory/batches/custom-fields',
      }
    ]),
    generateEntity('Stock Transfer', 'stock_transfer', '/admin-config/stock-transfer', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="STOCK_TRANSFER" />, props: {}, is_active: true, key: '/admin-config/stock-transfer/general',
      },
      ...generateCommonTabs('STOCK_TRANSFER'),
    ]),
    generateEntity('Stock Adjustment', 'stock_adjustment', '/admin-config/stock-adjustment', [
      ...generateCommonTabs('STOCK_ADJUSTMENT'),
      {
        name: 'Custom Reasons', component: <CustomReasons type="STOCK ADJUSTMENT" />, props: {}, key: '/admin-config/inventory/custom-reasons',
      },
    ]),
    generateEntity('Delivery Challan', 'delivery_challan', '/admin-config/delivery-challan', [
      ...generateCommonTabs('DELIVERY_CHALLAN'),
      {
        name: 'Document Status', component: <CustomStatus type="DELIVERY_CHALLAN" />, props: {}, key: '/admin-config/delivery-challan',
      },
    ]),
    generateEntity('Vendors', 'vendor', '/admin-config/vendors', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="VENDORS" />, props: {}, is_active: true, key: '/admin-config/vendors/general',
      },
      ...generateCommonTabs('VENDORS'),
      {
        name: 'Vendor Rating', component: <VendorRatingConfig />, props: {}, key: '/admin-config/vendors/rating',
      },
    ]),
    generateEntity('Material Request', 'purchase_request', '/admin-config/purchase-request', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="PURCHASE_REQUEST" />, props: {}, is_active: true, key: '/admin-config/purchase-request/general',
      },
      ...generateCommonTabs('PURCHASE_REQUEST'),
    ]),
    generateEntity('Purchase Indent', 'purchase_indent', '/admin-config/purchase-indent', [
      // {
      //   name: 'General Configuration', component: <GeneralConfiguration entityType="PURCHASE_INDENT" />, props: {}, is_active: true, key: '/admin-config/purchase-indent/general',
      // },
      ...generateCommonTabs('PURCHASE_INDENT'),
    ]),
    generateEntity('Purchase Order', 'purchase_order', '/admin-config/purchase-order', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="PURCHASE_ORDER" />, props: {}, is_active: true, key: '/admin-config/purchase-order/general',
      },
      ...generateCommonTabs('PURCHASE_ORDERS'),
      {
        name: 'Extra Charges', component: <ExtraCharges entityType="PURCHASE_ORDER" />, props: {}, is_active: true, key: '/admin-config/purchase-order/extra-charges',
      },
    ]),
    generateEntity('Good Receiving Note', 'good_receiving_note', '/admin-config/goods-receiving', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="GOOD_RECEIVING_NOTE" />, props: {}, is_active: true, key: '/admin-config/goods-receiving/general',
      },
      ...generateCommonTabs('GOOD_RECEIVING_NOTES'),
    ]),
    generateEntity('Account Payable Invoice', 'account_payable_invoice', '/admin-config/account-payable-invoice', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="ACCOUNT_PAYABLE_INVOICE" />, props: {}, is_active: true, key: '/admin-config/account-payable-invoice/general',
      },
      ...generateCommonTabs('ACCOUNT_PAYABLE_INVOICE'),
    ]),
  generateEntity('Gate Document', 'gate_document', '/admin-config/gate_document', [
    ...generateCommonTabs('GATE_DOCUMENT'),
  ]),
    generateEntity('Debit Note', 'debit_note', '/admin-config/debit-note', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType='DEBIT_NOTE' />, props: {}, is_active: true, key: '/admin_config/debit_note/general',
      },
      ...generateCommonTabs('DEBIT_NOTE'),
    ]),
    generateEntity('Vendor Payout', 'vendor_payout', '/admin-config/vendor-payments', generateCommonTabs('VENDOR_PAYOUT')),
    generateEntity('Bill Of Material', 'bill_of_materials', '/admin-config/bill-of-material', [
      ...generateCommonTabs('BILL_OF_MATERIAL'),
      {
        name: 'Custom Charges', component: <CustomReasons type = "BILL_OF_MATERIAL" />, props: {}, is_active: true, key: '/admin-config/bill-of-material/custom-charges',
      }, 
    ]),
    generateEntity('Manufacturing Order', 'manufacturing_order', '/admin-config/manufacturing-order', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="MANUFACTURING_ORDER" />, props: {}, is_active: true, key: '/admin-config/manufacturing-order/general',
      },
      ...generateCommonTabs('MANUFACTURING_ORDER')]),
    generateEntity('Customers', 'customer', '/admin-config/customer', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="CUSTOMERS" />, props: {}, is_active: true, key: '/admin-config/customers/general',
      },
      ...generateCommonTabs('CUSTOMERS'),
    ]),
    generateEntity(documentUINames.estimateUIName, 'sales_estimate', '/admin-config/estimate', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="SALES_ESTIMATE" />, props: {}, is_active: true, key: '/admin-config/SALES_ESTIMATE/general',
      },
      ...generateCommonTabs('SALES_ESTIMATE'),
      {
        name: 'Document Status', component: <CustomStatus type="SALES_ESTIMATE" />, props: {}, key: '/admin-config/estimate/custom-status',
      },
    ]),
    generateEntity(documentUINames.salesOrderUIName, 'sales_order', '/admin-config/sales-order', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="SALES_ORDER" />, props: {}, is_active: true, key: '/admin-config/SALES_ORDER/general',
      },
      ...generateCommonTabs('SALES_ORDER'),
      {
        name: 'Document Status', component: <CustomStatus type="SALES_ORDER" />, props: {}, key: '/admin-config/sales-order/custom-status',
      },
      {
        name: 'Extra Charges', component: <ExtraCharges entityType="SALES_ORDER" />, props: {}, is_active: true, key: '/admin-config/sales-order/extra-charges',
      },
    ]),
    generateEntity('Annual Maintenance Contract', 'annual_maintenance_contract', '/admin-config/annual_maintenance_contract', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="ANNUAL_MAINTENANCE_CONTRACT" />, props: {}, is_active: true, key: '/admin-config/annual_maintenance_contract/general',
      },
      ...generateCommonTabs('ANNUAL_MAINTENANCE_CONTRACT'),
      {
        name: 'Document Status', component: <CustomStatus type="ANNUAL_MAINTENANCE_CONTRACT" />, props: {}, key: '/admin-config/annual_maintenance_contract/custom-status',
      },
    ]),
    generateEntity('Packing Slip', 'packing_slip', '/admin-config/packing-slip', [
      // {
      //   name: 'General Configuration', component: <GeneralConfiguration entityType="PACKING_SLIP" />, props: {}, is_active: true, key: '/admin-config/PACKING_SLIP/general',
      // },
      ...generateCommonTabs('PACKING_SLIP'),
      {
        name: 'Document Status', component: <CustomStatus type="PACKING_SLIP" />, props: {}, key: '/admin-config/packing-slip/custom-status',
      },
    ]),
    generateEntity('Invoice', 'invoice', '/admin-config/invoice', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="INVOICE" />, props: {}, is_active: true, key: '/admin-config/invoice/general',
      },
      ...generateCommonTabs('INVOICE'),
      {
        name: 'Document Status', component: <CustomStatus type="INVOICE" />, props: {}, key: '/admin-config/invoice/custom-status',
      },
    ]),
    generateEntity('Consumption Order', 'consumption', '/admin-config/consumption', [
      ...generateCommonTabs('CONSUMPTION_ORDER'),
      {
        name: 'Document Status', component: <CustomStatus type="CONSUMPTION_ORDER" />, props: {}, key: '/admin-config/consumption/custom-status',
      },
    ]),
    generateEntity('Credit Note', 'credit_note', '/admin-config/credit-note', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="CREDIT_NOTE" />, props: {}, is_active: true, key: '/admin-config/credit-note/general',
      },
      ...generateCommonTabs('CREDIT_NOTE'),
    ]),
    generateEntity('Return Slip', 'return_slip', '/admin-config/return-slip', [
      {
        name: 'General Configuration', component: <GeneralConfiguration entityType="RETURN_SLIP" />, props: {}, is_active: true, key: '/admin-config/return-slip/general',
      },
      ...generateCommonTabs('RETURN_SLIP'),
    ]),
  ];
};

export default data;
